export class SaleReportFilter {
  public constructor() {
  }

  public PrescDateFrom?: any;
  public PrescDateTo?: any;

  public FactorDateFrom?: any;
  public FactorDateTo?: any;
  
  public TotalPriceFrom?: string;
  public TotalPriceTo?: string;
  public PaidPriceFrom?: string;
  public PaidPriceTo?: string;
  public InsurancePriceFrom?: string;
  public InsurancePriceTo?: string;
  
  public TaminPresc?: boolean;
  public FreePresc?: boolean;
  public Presc?: boolean;
  public OTC?: boolean;
  public SalamatPresc?: boolean;

  public Paid?: boolean;
  public OnPayment?: boolean;
  public Return?: boolean;
  public ReturnComplete?: boolean;
  public NoPayment?: boolean;
}

